export const SHARED_AUTH_MIGRATION_KEY = "pinoSharedAuthCookieMigrated";

export type SharedAuthAction = "use-cookie" | "migrate-persisted" | "clear-persisted" | "guest";

interface SharedAuthCredentialInput {
  cookieToken: string;
  persistedToken: string;
  migrationCompleted: boolean;
}

export interface SharedAuthCredentialResolution {
  action: SharedAuthAction;
  token: string;
  identityChanged: boolean;
}

export function hasCompletedSharedAuthMigration(): boolean {
  return typeof localStorage !== "undefined" && localStorage.getItem(SHARED_AUTH_MIGRATION_KEY) === "1";
}

export function markSharedAuthMigrationCompleted(): void {
  if (typeof localStorage !== "undefined") {
    localStorage.setItem(SHARED_AUTH_MIGRATION_KEY, "1");
  }
}

export function resolveSharedAuthCredential({
  cookieToken,
  persistedToken,
  migrationCompleted,
}: SharedAuthCredentialInput): SharedAuthCredentialResolution {
  if (cookieToken) {
    return {
      action: "use-cookie",
      token: cookieToken,
      identityChanged: cookieToken !== persistedToken,
    };
  }

  if (persistedToken && !migrationCompleted) {
    return {
      action: "migrate-persisted",
      token: persistedToken,
      identityChanged: false,
    };
  }

  if (persistedToken) {
    return {
      action: "clear-persisted",
      token: "",
      identityChanged: true,
    };
  }

  return {
    action: "guest",
    token: "",
    identityChanged: false,
  };
}
